import React from 'react'

import { VariantConfigurationEntry } from '../../../../../../inspector'
import {
  AttributeList,
  CollapsibleInspectorSection,
  FullCopyAttribute,
} from '../../components'

interface VariantConfigurationProps {
  /**
   * Optional because it can be absent for older/cached scenes or non-variant
   * elements — the components tolerate `undefined` and render nothing.
   */
  entries: VariantConfigurationEntry[] | undefined
}

/**
 * Renders a variant set's property/value pairs (e.g. Type=Primary,
 * State=Enabled) as copiable attribute rows. Used both inside the Symbol
 * section for symbol instances and in a dedicated section for variant masters.
 */
export const VariantConfigurationRows: React.FCC<VariantConfigurationProps> = ({
  entries,
}) => (
  <AttributeList data-testid="inspector-sidebar-variants">
    {(entries ?? []).map(({ propertyId, propertyName, valueName }) => (
      <FullCopyAttribute
        key={propertyId}
        label={propertyName}
        value={valueName}
      />
    ))}
  </AttributeList>
)

/**
 * A dedicated inspector section listing the variant configuration of a symbol
 * master that belongs to a variant set. Renders nothing for standalone masters.
 */
export const VariantConfigurationSection: React.FCC<
  VariantConfigurationProps
> = ({ entries }) => {
  if (!entries?.length) {
    return null
  }

  return (
    <CollapsibleInspectorSection
      identifier="variant"
      title="Variant"
      data-testid="inspector-sidebar-variant"
    >
      <VariantConfigurationRows entries={entries} />
    </CollapsibleInspectorSection>
  )
}
